import { unsafeTag } from "@cartographerio/util";
import { RoleV2 } from "../types.generated";

export function unsafeRoleV2(str: string): RoleV2 {
  return unsafeTag<"RoleV2">(str);
}
